import { render } from "./RegisterUser.vue?vue&type=template&id=31fd3690&scoped=true&ts=true"
import script from "./RegisterUser.vue?vue&type=script&lang=ts"
export * from "./RegisterUser.vue?vue&type=script&lang=ts"

import "./RegisterUser.vue?vue&type=style&index=0&id=31fd3690&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fd3690"]])

export default __exports__